<template>
  <div class="content">
    <p>
      {{ $t('sendInformation.title') }}
    </p>
    <base-button @click="navigateNextPage">{{
      $t('sendInformation.yeahSure')
    }}</base-button>
    <base-button @click="navigateNextPage">{{
      $t('sendInformation.noThanks')
    }}</base-button>
  </div>
  <div class="pagenumber">
    <label>5/7</label>
  </div>
</template>

<script>
export default {
  methods: {
    navigateNextPage() {
      this.$router.push('/askedcontact');
    },
  },
};
</script>
